import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import SEO from '@/components/base/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import MovieCard from '@/components/feature/MovieCard';
import { movies, categories } from '@/mocks/movies';

const staticTitles: Record<string, string> = {
  'sci-fi': '科幻电影',
  action: '动作电影',
  comedy: '喜剧电影',
  romance: '爱情电影',
  horror: '恐怖电影',
  animation: '动画电影',
  suspense: '悬疑电影',
  war: '战争电影',
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const categoryName = staticTitles[slug || ''] || '分类';
  const catInfo = categories.find((c) => c.slug === slug);
  const filteredMovies = movies.filter((m) => m.category === slug);

  const [selectedSlug, setSelectedSlug] = useState(slug || '');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  const handleCategoryChange = (newSlug: string) => {
    setSelectedSlug(newSlug);
    navigate(`/category/${newSlug}`);
  };

  const pageTitle = `${categoryName} - 琪琪影院高清蓝光免费在线看`;
  const pageDescription = `琪琪影院${categoryName}大全在线观看，精选热门${categoryName}，高清蓝光画质免费看不缓冲，海量${categoryName}片库每日更新。`;
  const pageKeywords = `${categoryName},琪琪影院,${categoryName}在线看,高清电影,蓝光电影,免费电影大全`;

  return (
    <>
      <SEO
        title={pageTitle}
        description={pageDescription}
        keywords={pageKeywords}
        canonicalUrl={`https://qiqicinema.com/category/${slug}`}
      />
      <div className="min-h-screen bg-background-100">
        <Navbar />
        <main className="pt-16">
          <div className="mx-auto max-w-[1400px] px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: categoryName },
              ]}
            />
          </div>

          <div className="bg-background-50 py-8 md:py-12">
            <div className="mx-auto max-w-[1400px] px-4 md:px-6">
              <div className="mb-8">
                <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-2">
                  {categoryName}
                </h1>
                <p className="text-sm text-foreground-500">
                  共 {filteredMovies.length} 部{categoryName} - 高清蓝光画质免费在线看
                </p>
              </div>

              <div className="flex items-center gap-2 mb-8 overflow-x-auto scrollbar-hide pb-2">
                <div className="flex bg-secondary-100 rounded-full p-1 gap-1">
                  {categories.map((cat) => (
                    <button
                      key={cat.slug}
                      onClick={() => handleCategoryChange(cat.slug)}
                      className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                        cat.slug === slug
                          ? 'bg-primary-500 text-background-50'
                          : 'text-foreground-600 hover:text-foreground-900'
                      }`}
                    >
                      {cat.name}
                    </button>
                  ))}
                </div>
              </div>

              {filteredMovies.length > 0 ? (
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5" data-product-shop="">
                  {filteredMovies.map((movie) => (
                    <MovieCard key={movie.id} movie={movie} />
                  ))}
                </div>
              ) : (
                <div className="text-center py-20">
                  <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-secondary-100">
                    <i className="ri-movie-2-line text-2xl text-foreground-400"></i>
                  </div>
                  <p className="text-foreground-500">暂无此类电影资源</p>
                </div>
              )}
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}